import createReactClass from 'create-react-class';
('use strict');

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
// Import JS Modules
import {
  ABLE_TO_RESIZE,
  localFileResize,
} from './loader-mixins/local-file-resize';
import GenericPaginatedUploadMixin from './loader-mixins/generic-paginated-upload-mixin';
import UploadAnalytics from './upload-analytics';
import { builderDispatch, WebUI } from '../_utils/ui';
import DPI from './utils/dpi';
import FileClearingMixin from './loader-mixins/file-clearing-mixin';
import FileSelectorMixin from './loader-mixins/file-selector-mixin';
import PrintSizeSelector from './print-size-selector';
import UploadButton from './utils/upload-button';
import AlbumSelector from './album-selector';
import CustomText from './custom-text';
import ImageUploadFileValidator from '../_utils/image-upload-file-validator';
import AnalyticsHandler from '../_libs/analytics/checkout-google-analytics';
import sendToGoogleAnalytics from '../_prism-builder/desktop/slot-tools/send-to-google-analytics';
import LoaderAdditionalOptions from './additional-options';

const LocalFileImportNative = createReactClass({
  mixins: [GenericPaginatedUploadMixin, FileSelectorMixin, FileClearingMixin],
  displayName: 'Local file import native',

[LoaderAdditionalOptions.CLOSE_ON_FILE_SELECTION]: true,

  getInitialState() {
    const { App } = window;
    this.files = this.files || [];

    return {
      loggedIn: App && App.order.logged_in(),
    };
  },
  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      if (payload.type === WebUI.LOGIN) {
        this.setState({
          loggedIn: true,
        });
      }
    });
    const component = ReactDOM.findDOMNode(this);
    component.addEventListener('dragover', this.handleDragOver, false);
    component.addEventListener('dragenter', this.handleDragEnter, false);
    component.addEventListener('dragleave', this.handleDragLeave, false);
    component.addEventListener('drop', this.handleDrop, false);
  },
  componentWillUnmount() {
    const component = ReactDOM.findDOMNode(this);
    component.removeEventListener('dragover', this.handleDragOver, false);
    component.removeEventListener('dragenter', this.handleDragEnter, false);
    component.removeEventListener('dragleave', this.handleDragLeave, false);
    component.removeEventListener('drop', this.handleDrop, false);
  },
  sendAnalytics(eventCategory) {
    const eventLabel = UploadAnalytics.eventTypes(
      this.files.map(f => f.uploadAnalytics)
    );

    const payload = {
      type: WebUI.Analytics.SEND,
      eventCategory: eventCategory,
      eventAction: 'device',
      eventLabel: eventLabel,
      eventValue: this.files.length,
    };

    AnalyticsHandler.handleAnalyticsEvent(payload);
  },

  render() {
    return (
      <div
        id={'image-loader-service-' + this.props.service}
        style={{ height: this.props.height }}
        className={classNames(
          'text-center image-loader-service',
          this.props.service,
          { 'd-none': !this.props.isActive }
        )}
        tabIndex="0">
        <div className="d-flex d-md-none h-100 flex-column justify-content-center">
          <i className="d-none d-lg-block large fas fa-laptop" />
          <i className="mx-auto d-lg-none large fas fa-mobile-alt" />
          <h3 className="title service-title font-weight-bold">My Phone</h3>
          <small>Upload photos from your phone.</small>
          <div className="mobile-file-upload-btn">
            <UploadButton
              label="Upload"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>
          <CustomText
            textKey="imageLoaderLocalFileImportBannerHtml"
            className="local-file-import-banner local-file-import-banner-mweb d-none"
          />
        </div>
        <div id="fileList" />
        <div
          id="dropArea"
          className="d-none d-md-flex h-100 flex-column justify-content-center align-items-center">
          <div className="album-selector-box d-none">
            <div className="image-loader-form-elements">
              {!!this.state.loggedIn && (
                <AlbumSelector
                  targetAlbum={this.props.targetAlbum}
                  onAlbumSelected={this.handleTargetAlbumSelected}
                />
              )}
              <PrintSizeSelector />
            </div>
          </div>
          <div className="device">
            <i className="large fas fa-cloud-upload-alt" />
            <h3 className="title font-weight-bold">Drag &amp; Drop Here</h3>
            <small className="d-block">*Upload only jpeg or jpg.</small>
            <UploadButton
              label="Upload Photos"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>

          <CustomText
            textKey="imageLoaderLocalFileImportBannerHtml"
            className="local-file-import-banner local-file-import-banner-rweb d-none"
          />
        </div>
      </div>
    );
  },

  handleTargetAlbumSelected(album) {
    if (this.props.onTargetAlbumSelected)
      this.props.onTargetAlbumSelected(album);
  },

  draggable() {
    return (
      'draggable' in document.createElement('span') && !this.props.isMobile
    );
  },

  handleDragOver(e) {
    e.stopPropagation();
    e.preventDefault();
  },

  dragCounter: 0,
  handleDragEnter(e) {
    e.preventDefault();

    if (this.dragCounter++ === 0) $('#dropArea').addClass('dragover');
  },

  handleDragLeave(e) {
    if (--this.dragCounter === 0) $('#dropArea').removeClass('dragover');
  },

  handleDrop(e) {
    e.preventDefault();

    this.dragCounter = 0;
    $('#dropArea').removeClass('dragover');

    const files = Array.prototype.slice.apply(e.dataTransfer.files);
    this.addFiles(files);

    return false;
  },

  triggerFeatureTracking() {
    sendToGoogleAnalytics('local-import', '');
  },


  handleFileInputChange(e) {
    this.triggerFeatureTracking();
    const $fileInput = e.target;
    const files = Array.from($fileInput.files);

    if (!files.length) return;

    this.addFiles(files);
    $fileInput.value = '';
  },

  addFiles(files) {
    const filteredFiles = files.filter(
      this.props.fileValidator.isAcceptedFileType
    );

    if (!!filteredFiles.length) {
      this.files = this.files.concat(filteredFiles);
      this.props.onFilesSelected();
    }
  },

  _buildFormData(formData, file) {
    var deferred = $.Deferred();

    formData.append('name', file.name);
    if (ABLE_TO_RESIZE) {
      localFileResize(
        file,
        this.props.optimiseUploadFiles ? DPI.DPI_300 : DPI.DPI_HIGH,
        appendFile
      );
    } else {
      appendFile(file);
    }

    return deferred.promise();

    function appendFile(file) {
      formData.append('file', file);
      deferred.resolve(formData);
    }
  },
});

LocalFileImportNative.defaultProps = {
  fileValidator: new ImageUploadFileValidator(),
};

export default LocalFileImportNative;
